export function getProvider(queryParams) {
    /*var provider = queryParams.provider;

    if (!provider){
        provider = '0';
    }*/
    return queryParams.provider;

}

export function getManagers(queryParams) {
    return queryParams.managers;
}

export function getDealType(queryParams) {
    /*var dealtype = queryParams.dealtype;

    if (!dealtype){
        dealtype = '0';
    }*/
    return queryParams.dealtype;
}

export function getStore(queryParams) {
    return queryParams.store;
}

export function getDate(queryParams,defaultDate) {

    let date = queryParams.date;
    let startDate = queryParams.startDate;
    let endDate = queryParams.endDate;

    if (!date){
        if(defaultDate) {
            date = defaultDate
        }
        else {
            date = 'this_month';
        }
    }

    if(!startDate){
        startDate = '';
        endDate = '';
    }
    else {
        endDate = endDate.replace('00:00:00', '23:59:59');
    }
    /*else {
        startDate = startDate.split('T')[0];
        startDate = startDate + "T00:00:00Z";

        endDate = endDate.split('T')[0];
        endDate = endDate + "T00:00:00Z";

        //startDate = "2018-07-28T00:00:00Z";
        //endDate = "2018-08-06T00:00:00Z";
    }*/

    return {date: date, startDate: startDate.replace(/['"]+/g, ''), endDate: endDate.replace(/['"]+/g, '')};
}

export function getSignUpDate(queryParams){
    let date = queryParams.signUpDate;
    let startDate = queryParams.signUpStartDate;
    let endDate = queryParams.signUpEndDate;

    if (!date){
        date = 'any_time';
    }

    if(!startDate){
        startDate = '';
        endDate = '';
    }
    else {
        endDate = endDate.replace('00:00:00', '23:59:59');
    }
    return {date: date, startDate: startDate.replace(/['"]+/g, ''), endDate: endDate.replace(/['"]+/g, '')};
}

export function getFtdDate(queryParams){
    let date = queryParams.ftdDate;
    let startDate = queryParams.ftdStartDate;
    let endDate = queryParams.ftdEndDate;

    if (!date){
        date = 'any_time';
    }

    if(!startDate){
        startDate = '';
        endDate = '';
    }
    else {
        endDate = endDate.replace('00:00:00', '23:59:59');
    }
    return {date: date, startDate: startDate.replace(/['"]+/g, ''), endDate: endDate.replace(/['"]+/g, '')};
}

export function getMonthDate(queryParams) {
    let date = queryParams.date;
    if (!date){
        date = 'this_month';
    }

    return date;
}

export function getStatus(queryParams) {
    /*var status = queryParams.status;

    if (!status){
        status = '0';
    }*/
    return queryParams.status;
}

export function getSecondStatus(queryParams) {
    /*var status = queryParams.secondStatus;

    if (!status && status !== 0){
        status = -1;
    }*/
    return queryParams.secondStatus;
}

export function getIsNew(queryParams) {
    return queryParams.isNew;
}

export function getDuplicate(queryParams) {
    return queryParams.duplicate;
}

export function getCountry(queryParams) {
    var country = queryParams.country;

    if (!country){
        country = '0';
    }
    return country;
}

export function getProduct(queryParams) {
    var product = queryParams.product;

    if (!product){
        product = '0';
    }
    return product;
}

export function getPlatform(queryParams) {
    var platform = queryParams.platform;

    if (!platform){
        platform = '0';
    }
    return platform;
}

export function getAccount(queryParams) {
    var accountID = queryParams.accountID;

    if (!accountID){
        accountID = '0';
    }
    return accountID;
}

export function getAffiliate(queryParams) {
    var affiliateID = queryParams.affiliateID;

    if (!affiliateID){
        affiliateID = '0';
    }
    return affiliateID;
}

export function getReportType(queryParams) {
    var reportType = queryParams.reportType;

    if (!reportType){
        reportType = 'total';
    }
    return reportType;
}

export function getPromotion(queryParams) {
    var promotion = queryParams.promotion;

    if (!promotion){
        promotion = '0';
    }
    return promotion;
}

export function getOffer(queryParams) {
    var offer = queryParams.offer;

    if (!offer){
        offer = '0';
    }
    return offer;
}

export function getLanguage(queryParams) {
    var language = queryParams.language;

    if (!language){
        language = '0';
    }
    return language;
}

export function getCreativeType(queryParams) {
    var creativeType = queryParams.creative_type;

    if (!creativeType){
        creativeType = '0';
    }
    return creativeType;
}

export function getCreativeSize(queryParams) {
    var creativeSize = queryParams.creative_size;

    if (!creativeSize){
        creativeSize = '0';
    }
    return creativeSize;
}

export function getFTDdate(queryParams) {
    var ftdDate = queryParams.ftdDate;

    if (!ftdDate){
        ftdDate = false;
    }
    return ftdDate;
}

export function getFirstBet(queryParams) {
    var firstBet = queryParams.firstBet;

    if (!firstBet){
        firstBet = false;
    }
    return firstBet;
}
